import { useUIStore, useIssueStore } from '@/stores';
import { StaggeredMenu } from '@/components/ui';
import { Clock, ListTodo, AlertCircle, FileText, FolderOpen } from 'lucide-react';

export function Sidebar() {
  const { isSidebarOpen, toggleSidebar, showToast } = useUIStore();
  const { setActiveView } = useIssueStore();

  const menuItems = [
    {
      label: 'Project Timing',
      icon: Clock,
      onClick: () => {
        setActiveView('timing');
        showToast('切换到项目时间线视图', 'success');
      },
    },
    {
      label: 'Task Management',
      icon: ListTodo,
      onClick: () => {
        showToast(
          <span className="flex items-center gap-2">
            功能开发中，敬请期待！
          </span>,
          'info'
        );
      },
    },
    {
      label: 'Open Issues',
      icon: AlertCircle,
      onClick: () => {
        setActiveView('issues');
        showToast('切换到问题管理视图', 'success');
      },
    },
    {
      label: 'Document Audit',
      icon: FileText,
      onClick: () => {
        showToast(
          <span className="flex items-center gap-2">
            功能开发中，敬请期待！
          </span>,
          'info'
        );
      },
    },
  ];

  return (
    <StaggeredMenu
      isOpen={isSidebarOpen}
      onClose={toggleSidebar}
      items={menuItems}
      position="left"
      colors={['#B19EEF', '#5227FF']}
      accentColor="#515152"
      menuButtonColor="#fcf7f7"
      displayItemNumbering={true}
    />
  );
}
